import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.707 9.293l-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414",
  fillRule: "evenodd"
});

var SvgArrowRightMinor = function SvgArrowRightMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgArrowRightMinor as S };
